const gradientText = (theme) => ({
  backgroundImage:
    "linear-gradient(90deg, #BE48FF 0%, #3152CE 35%, #53A1F7 60%, #79F3C7 90%)",
  backgroundSize: "cover",
  "-webkit-background-clip": "text",
  "-webkit-text-fill-color": "transparent",
  // See https://forum.webflow.com/t/multi-line-gradient-text-safari-ios-fix-i-e-prevent-disappearing-text/135029
  "-webkit-box-decoration-break": "clone",
  "::selection": {
    "-webkit-text-fill-color": `${theme.colours.black}`,
  },
});

const bigLink = `
  text-decoration: none;
  text-align: center;
  padding: 20px 65px;
  border-radius: 40px;
  position: relative;
  font-size: 16px;
  animation: scaleOut ease 0.1s;
  animation-fill-mode: forwards;
  will-change: transform,opacity;

  &:hover {
    animation: scaleIn ease 0.2s;
    animation-fill-mode: forwards;
  }
`;

const brandStyles = {
  gradientText,
  bigLink,
};

export default brandStyles;
